import { autocompleteClasses, AutocompleteGetTagProps, Chip, styled, useAutocomplete } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import { useContext, useEffect } from "react";
import * as React from 'react';

const InputWrapper = styled('div')(
    ({ theme }) => `
    border: 1px solid ${theme.palette.mode === 'dark' ? '#434343' : '#d9d9d9'};
    background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
    border-radius: 4px;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
  
    &:hover {
      border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
    }
  
    &.focused {
      border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  
    & input {
      background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
      color: ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,.85)'
        };
      height: 30px;
      box-sizing: border-box;
      padding: 4px 6px;
      width: 0;
      min-width: 30px;
      flex-grow: 1;
      border: 0;
      margin: 0;
      outline: 0;
    }
  `,
);
const Listbox = styled('ul')(
    ({ theme }) => `
    margin: 2px 0 0;
    padding: 0;
    position: absolute;
    list-style: none;
    background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
    overflow: auto;
    max-height: 250px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1;
  
    & li {
      padding: 5px 12px;
      display: flex;
  
      & span {
        flex-grow: 1;
      }
  
      & svg {
        color: transparent;
      }
    }
  
    & li[aria-selected='true'] {
      background-color: ${theme.palette.mode === 'dark' ? '#2b2b2b' : '#fafafa'};
      font-weight: 600;
  
      & svg {
        color: #1890ff;
      }
    }
  
    & li.${autocompleteClasses.focused} {
      background-color: ${theme.palette.mode === 'dark' ? '#003b57' : '#e6f7ff'};
      cursor: pointer;
  
      & svg {
        color: currentColor;
      }
    }
  `,
);





const AutoCompletePeople = (props: any) => {
    const [editEventValue,setEditEventValue] = React.useState([])
    const {
        getRootProps,
        getInputProps,
        getTagProps,
        getListboxProps,
        getClearProps,
        getOptionProps,
        groupedOptions,
        value,
        focused,
        anchorEl,
        setAnchorEl,
    } = useAutocomplete({
        id: 'hook-demo',
        multiple: true,
        options: props.people,
        defaultValue:props.list.length > 0 ? [...props.list] : [], 
        getOptionLabel: (option: any) => `${option.user.first_name} ${option.user.last_name}`,
    })
    useEffect(() => {
        props.valueChange(value.map((elm:any) => {
            return elm.user
        }))
    },[value])
    return (
        <div>
            <div {...getRootProps()}>
                <label className='required'>Participant List:</label>
                <InputWrapper ref={setAnchorEl} className={focused ? 'focused' : ''}>
                    {value.map((option: any, index: number) => (
                        <Chip
                            label={`${option.user.first_name} ${option.user.last_name}`}
                            className="chip font-weight-700"
                            {...getTagProps({ index })}
                        />
                    ))}
                    <input {...getInputProps()} />
                </InputWrapper>
            </div>
            {groupedOptions.length > 0 ? (
                <Listbox {...getListboxProps()}>
                    {(groupedOptions as typeof props.people).map((option: any, index: any) => (
                        <li {...getOptionProps({ option, index })}>
                            <span>{`${option.user.first_name} ${option.user.last_name}`}</span>
                            <CheckIcon fontSize="small" />
                        </li>
                    ))}
                </Listbox>
            ) : null}
        </div>
    )

}
export default AutoCompletePeople